import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

import { LibraryScreen } from './-components/library-screen.tsx'

export const Route = createFileRoute('/studio/library')({
  component: LibraryPage
})

function LibraryPage(): JSX.Element {
  return <LibraryScreen />
}
